import { localStorageManager } from '~/gateways/storage/localStorageManager';
import { MagicUseCase } from '../magicUseCase';

export class LoadLikedUnitsUseCase extends MagicUseCase {
  protected async runLogic() {
    this.getState().user.likedUnitIds = localStorageManager.getLikedUnitIds();
  }
}
